import Page from "webPage/Page";

import {handleScrollingSection} from "util/scrolling-section";
import StyleGallery from "StyleGallery";

Page.register('page-template-quiz-result', () => {
    handleScrollingSection($(".js-rating-track-wrap"), 0, 1199);


    let $galleries = $('.js-gallery');
    if ($galleries.length > 0) {
        $galleries.each((index, gallery) => {
            new StyleGallery($(gallery));
        });
    }
});
